import { ChangeDetectorRef, Component, QueryList, ViewChildren } from '@angular/core';
import { FiltersM, typesApex } from '../../../components/models';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { companiesFinanciero, companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { CuentaEntity, EvaluacionEntity, Detalle_Evaluacion_CuentaEntity } from '../../funciones/AlertaTemprana';
import { calculos, periodos } from '../../funciones/funcionesGenerales';
import { messages } from '../../funciones/mensajes';
import { HttpHeaders } from '@angular/common/http';
import { getCuenta } from '../../../services/riesgo-liquidez/query';
import { activosPonderados, obtenerCodigoPropio } from '../../financiero-alerta/idsTablas';
import { IndicadoresCoberturaService } from '../../../services/financiero/indicadores-cobertura/indicadores-cobertura.service';
import { CalcesPlazos } from '../tablaslds';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { table } from '../../../shared/GenerateTabla/plantillas/models.model';
import { TemplateLoaderService } from '../../../shared/GenerateTabla/plantillas/template-loader.service';
import { TableroService } from '../../../shared/GenerateTabla/services/tablero.service';

@Component({
  selector: 'app-calces-plazos',
  templateUrl: './calces-plazos.component.html',
  styleUrl: './calces-plazos.component.css'
})
export class CalcesPlazosComponent {
  @ViewChildren(GraficadorComponent) grafCmp!: QueryList<GraficadorComponent>;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public Filters = FiltersM;
  public Periodos = [];
  public periodoSeleccionado;
  private cuentaEntity = new CuentaEntity;
  private evaluacionEntity = new EvaluacionEntity;
  private idAdministrador = '';
  public subTitles = '';
  public cadenaEvaluacion = [];
  public tipoMoneda = []
  public monedaSelec;
  private dataAll = [];
  public dataFlujo = [];
  public dataComposicion = [];
  public dataActivos = [];
  public dataPasivos = [];
  public dataTotales = [];  
  public limiteReg;
  public tarjetas = [];
  public typeGrap = typesApex;
  public grafCalce = {titulo: '', filtroActivado: false, showLabels: false, tipo: this.typeGrap.LINE, data: [], etiquetas:[]};
  public grafComposicion = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.DONUT, data: [], etiquetas:[]};
  public grafActivos = {titulo: '', filtroActivado: false, showLabels: false, tipo: this.typeGrap.BARHORIZONTAL, data: [], etiquetas:[]};
  public grafPasivos = {titulo: '', filtroActivado: false, showLabels: false, tipo: this.typeGrap.BARHORIZONTAL, data: [], etiquetas:[]};
  public colores = ['#097ba7','#0d94c7','#aecee8','#6ab0dc']
  public verTablaCalce: boolean = false; 
  public verTablaComp: boolean = false;// false -> Tabla de calces    false -> grafica de calces 
  public activosPasivos: boolean = true; //true => activos false => pasivos
  public monedaSeleccionada = 'mn-me';
  public modalOpen: boolean = false;
  public tituloModal = '';
  public subtituloModal = '';
  public graficaAmp = 0;
  public bandas = [];
  public titBanda = '';
  public bandaSelec;
  tablaConfig: table;
  tablaFEC: table;
  verTabla = false;
  //Variables de personalizacion
  public multiMoneda: boolean;
  public codigoPropio: boolean;
  public miles = ',';
  public decimal = '.';
  constructor(
    public dataService: DataService,
    private service: IndicadoresCoberturaService,
    private apollo: Apollo,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private cookieService: CookieService,
    private tableroService: TableroService,
    private readonly templateLoader: TemplateLoaderService,
    private excelService: ExcelService
  ) {
    this.cuentaEntity = new CuentaEntity;
    this.evaluacionEntity = new EvaluacionEntity;
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    const datosInst = companiesRiesgoLiquidez.find(i => i.id === this.evaluacionEntity.Id_Institucion+'');
    this.idAdministrador = datosInst?.idAdmin;
    this.evaluacionEntity.Id_Plantilla = datosInst?.idPlantilla;
    this.cuentaEntity.Id_Plantilla = datosInst?.idPlantilla;
    this.personalizacion();
  }

  private async personalizacion(){
    const settings = companiesFinanciero.find(i => i.id == this.evaluacionEntity.Id_Institucion+'');
    if(settings){
      this.multiMoneda = settings.multiMoneda;
      this.codigoPropio = settings.codigoPropio;
      this.tipoMoneda = [
        {id: 1, check: true, tit: 'mn-me', prop: 'total', name: 'Total'},
        {id: 2, check: false, tit: 'mn', prop: 'mn', name: 'Nacional'},
        {id: 3, check: false, tit: 'me', prop: 'me', name: 'Extranjera'}
      ];
      this.monedaSelec = this.tipoMoneda[0];
      this.getEvaluacion();
    }else{
      var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) ===  this.evaluacionEntity.Id_Institucion).name;
      const msg = await firstValueFrom(
        this.translate.get('swal.instNoInfo')
      );
      messages.infoMessageGraph(nombre + msg);
    }
  }
  /* Consultas */
  private async getEvaluacion(){
    try {
      
      const data = await this.service.getEvaluaciones(this.evaluacionEntity.Id_Plantilla);
      await this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private ordenamientoDataEvaluacion(datos){
    const info = periodos.obtenerPeriodos(datos, 1);
    this.Periodos = info.periodos;
    this.periodoSeleccionado = this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1];
    for(const an of this.Periodos){
      an.utilizable = false;
    }
    this.obtenerDataEvaluacion();
  }
  private async obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      if (this.Periodos[i].visible) {
        for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
          if (this.Periodos[i].series[j].check || (tot > 0 && tot < 12)) {
            this.cadenaEvaluacion.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos,
              an: this.Periodos[i].series[j].an,
              mes: this.Periodos[i].series[j].mes
            });
            tot++;
          }
        }
      }

    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.getDataFlujos();
    this.getDataFEC();
  }
  private async getDataFlujos(){
    const configuracion = this.templateLoader.obtenerConfiguracionCalcesPlazos(this.idAdministrador, this.monedaSelec.name);
    if(configuracion.filas){
      configuracion.id = this.evaluacionEntity.Id_Plantilla+'';
      const  tabla = await this.tableroService.getTabla(
        configuracion,
        this.cadenaEvaluacion,
        this.evaluacionEntity.Id_Plantilla
      );
      this.tablaConfig = tabla;      
      this.getDatosAT();      
    }else{
      messages.infoMessageGraph(configuracion);
    }
  }
  private async getDataFEC(){
    const configuracion = this.templateLoader.obtenerConfiguracionFEC(this.idAdministrador, this.monedaSelec.name);
    if(configuracion.filas){
      configuracion.id = this.evaluacionEntity.Id_Plantilla+'';
      const  tabla = await this.tableroService.getTabla(
        configuracion,
        this.cadenaEvaluacion,
        this.evaluacionEntity.Id_Plantilla
      );
      this.tablaFEC = tabla;
    }else{
      messages.infoMessageGraph(configuracion);
    }
  }
  private async getDatosAT(){
    try{
      const cuentasAT = CalcesPlazos.cuentasAT(this.cuentaEntity.Id_Plantilla);
      if(Object.keys(cuentasAT).length == 0){
        var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) === Number(this.evaluacionEntity.Id_Institucion)).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }else{
        const evaluaciones = this.Periodos.flatMap(a => a.series).filter(p => p.check);
        var datos = [];
        await this.getCuentas(cuentasAT['cuentas'], datos);
        await this.agregarACuentasTotal(
          cuentasAT['cuentas'],
          evaluaciones,
          this.service.getDetalleCuenta.bind(this.service),
          'detalleEvaluacionCuenta',
          'idCuenta',
          datos
        );
        // await this.agregarACuentasTotal(
        //   cuentasAT['varTemp'],
        //   evaluaciones,
        //   this.service.getVarTemp.bind(this.service),
        //   'detalleEvaluacionVarTemp',
        //   'idVarTemp',
        //   datos
        // );

        // await this.agregarACuentasTotal(
        //   cuentasAT['var'],
        //   evaluaciones,
        //   this.service.getVariable.bind(this.service),
        //   'detalleEvaluacionVariable',
        //   'idVariable',
        //   datos
        // );  
        this.getDatosTabla(datos);
      }      
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }  
  private async getCuentas(cuentas, cuentasTotal){
    try{
      for(const i of cuentas){
        const { data }  = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getCuenta,
            context: { headers: this.headers, },
            variables: { cuentaId: i, idPlantilla: this.cuentaEntity.Id_Plantilla, params:{
              id: i,
              idPlantilla: this.cuentaEntity.Id_Plantilla
            }}
          }).valueChanges.source
        );
        cuentasTotal[data.cuenta.id] ??= [];
        cuentasTotal[data.cuenta.id].push({
          descripcion: data.cuenta.descripcion,
          id: data.cuenta.id,
          series: []
        });
      }
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }     
  private async agregarACuentasTotal<T>(cuentas: string[],periodos: any[],servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal:any[]) {
    const promesas = periodos.flatMap(periodo =>
      cuentas.map(id =>
        servicio(periodo.id, id)
      )
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];
      cuentasTotal[idCuenta][0].series.push(detalle);
    });
  }
  private getDatosTabla(data){
    this.dataAll = data;
    const tablas = CalcesPlazos.tablas(this.cuentaEntity.Id_Plantilla);
    this.limiteReg = CalcesPlazos.limiteRegulatorio(this.cuentaEntity.Id_Plantilla);
    const keys = Object.keys(tablas);
    //CALCULOS DE LA TABLA DE COMPOSICION Y FLUJOS
    keys.forEach(e => {
      var dataTabla = [];
      for(var i = 1; ; i++){
        const d = tablas[e][i];
        if(d === undefined){break;} 
        else{
          let vmn = 0;
          let vme = 0;
          let t = 0;
          let p0_90, p1_30, p31_90;

          if(d.me !== ''){
            if(!d?.valor){
              vmn = data[d.mn][0].series[0].valor;
              vme = data[d.me][0].series[0].valor;  
            }            
          }else{
            if(d?.operacion){
              if(d.operacion != 'suma'){
                const formula = d.operacion
                const c = formula.split(' ');
                var signo = '';
                c.forEach(e => {
                  if(!isNaN(Number(e))){
                    vmn = calculos.operations(vmn, signo||'+' ,dataTabla[Number(e)-1].mn);
                    vme = calculos.operations(vme, signo||'+' ,dataTabla[Number(e)-1].me);                   
                    t = calculos.operations(t, signo||'+' ,dataTabla[Number(e)-1].total);                   
                  }else{
                    signo=e;
                  }
                })  
              }else{ //se calculan los totales sumando las columnas
                if(e == 'composicion'){
                  vmn = dataTabla.reduce((suma, cuenta) => suma + cuenta.mn, 0);
                  vme = dataTabla.reduce((suma, cuenta) => suma + cuenta.me, 0);
                  t = dataTabla.reduce((suma, cuenta) => suma + cuenta.total, 0);
                }else{
                  p0_90 = dataTabla.reduce(
                    (suma, cuenta) => ({
                      mn: suma.mn + (Number(cuenta.p0_90?.mn) || 0),
                      me: suma.me + (Number(cuenta.p0_90?.me) || 0),
                      total: suma.total + (Number(cuenta.p0_90?.total) || 0),
                    }),{mn: 0,me: 0,total: 0,}
                  );
                  p1_30 = dataTabla.reduce(
                    (suma, cuenta) => ({
                      mn: suma.mn + (Number(cuenta.p1_30?.mn) || 0),
                      me: suma.me + (Number(cuenta.p1_30?.me) || 0),
                      total: suma.total + (Number(cuenta.p1_30?.total) || 0),
                    }),{mn: 0,me: 0,total: 0,}
                  );
                  p31_90 = dataTabla.reduce(
                    (suma, cuenta) => ({
                      mn: suma.mn + (Number(cuenta.p31_90?.mn) || 0),
                      me: suma.me + (Number(cuenta.p31_90?.me) || 0),
                      total: suma.total + (Number(cuenta.p31_90?.total) || 0),
                    }),{mn: 0,me: 0,total: 0,}
                  );           
                }
                
              }              
            }
          }
          let codigomn = this.codigoPropio ? obtenerCodigoPropio.idsCodigoPropio(this.cuentaEntity.Id_Plantilla, d.mn)?.codigo : '';
          let codigome = this.codigoPropio ? obtenerCodigoPropio.idsCodigoPropio(this.cuentaEntity.Id_Plantilla, d.me)?.codigo : ''
          if(e == 'composicion'){
            dataTabla.push({
              codATmn: d.mn,
              codATme: d.me,
              codmn: codigomn,
              codme: codigome,
              descripcion: d?.descripcion ?? data[d.mn][0].descripcion,
              mn: vmn,
              me: vme,
              total: vmn + vme,
            });
          }else{
            if(!d?.descripcion){
              dataTabla.push({
                codATmn: d.mn,
                codATme: d.me,
                codmn: codigomn,
                codme: codigome,
                descripcion: d?.descripcion ?? data[d.mn][0].descripcion,
                p1_30: {mn: vmn, me: vme, total: vmn + vme},
                p31_90: {mn: vmn*1.5, me: vme*2, total: vmn*1.5 + vme*2},
                p0_90: {mn: vmn + (vmn*1.5), me: vme + (vme*2), total: (vmn + (vmn*1.5)) + (vme + (vme*2))},
              }); 
            }else{
              dataTabla.push({
                codATmn: d.mn,
                codATme: d.me,
                codmn: codigomn,
                codme: codigome,
                descripcion: d?.descripcion ?? data[d.mn][0].descripcion,
                p1_30: p1_30,
                p31_90: p31_90,
                p0_90: p0_90,
              }); 
            }
            
          }
          
        }
      }
      if(e == 'composicion') this.dataComposicion = dataTabla;
    });
    // CALCULAR CALCES 
    const totalActivos = this.tablaConfig.filas.find(i => i.id == 'SUBTOTAL_01').bandasValue;
    const totalPasivos = this.tablaConfig.filas.find(i => i.id == 'SUBTOTAL_02').bandasValue;
    let a = [], b = [], c = [], e = [];
    for(let i = 0; i < this.tablaConfig.filas[0].bandas.length; i++){
      a.push(totalActivos[i] - totalPasivos[i]);
      b.push(this.dataComposicion[this.dataComposicion.length - 1][this.monedaSelec.prop]);
      c.push(a[i] / b[i]);
      e.push(b[i] * this.limiteReg[i] + a[i]);
    }
    this.tablaConfig.filas.push({
      type: 'titulo',
      id: 'a',
      descripcion: 'A. Flujos activos - flujos pasivos',
      bandas: [1,1,1],
      bandasValue: a,
      visible: true
    });
    this.tablaConfig.filas.push({
      type: 'titulo',
      id: 'b',
      descripcion: 'B. Activos líquidos',
      bandas: [1,1,1],
      bandasValue: b,
      visible: true
    });
    this.tablaConfig.filas.push({
      type: 'titulo',
      id: 'c',
      descripcion: 'Calce Descalce (A/B)',
      bandas: [1,1,1],
      bandasValue: c,
      visible: true
    });
    this.tablaConfig.filas.push({
      type: 'titulo',
      id: 'lim',
      descripcion: 'Límite regulatorio',
      bandas: [1,1,1],
      bandasValue: this.limiteReg,
      visible: true
    });
    this.tablaConfig.filas.push({
      type: 'titulo',
      id: 'e',
      descripcion: 'Exceso déficit límite de crédito',
      bandas: [1,1,1],
      bandasValue: e,
      visible: true
    });
    this.verTabla = true;
    let encBandas =  this.tablaConfig.columnas.slice(this.tablaConfig.columnas.length - a.length);
    this.titBanda = encBandas[0].split(' ')[0];
    this.bandas = [];
    for(const enc of encBandas){
      this.bandas.push({
        titulo: enc,
        opcion: enc.split(' ').slice(1).join(' ')
      })
    }
    this.bandaSelec = this.bandas[0];
    this.grafCalce.etiquetas = this.tablaConfig.columnas.slice(this.tablaConfig.columnas.length - a.length);
    this.grafCalce.data = [
      {
        name: 'Calce descalce',
        data: c
      },
      {
        name: 'A. Flujo activos - fujos pasivos',
        data: a
      },
      {
        name: 'B. Activos líquidos(BG)',
        data: b
      },
      {
        name: 'Exceso déficit límite de crédito',
        data: e
      }
    ]
    this.graficaComposicion();
    this.graficasActivoPasivo();
  }
  private graficaComposicion (){
    let aux = [], etiquetas = [];
    let p = this.monedaSelec.prop;
    for(const d of this.dataComposicion){
      if(d.codATmn !== 'total'){
        aux.push(d[p]);
        etiquetas.push(d.descripcion);
      }
    }
    this.grafComposicion.etiquetas = etiquetas;
    this.grafComposicion.data = [{
      name: '',
      data: aux,
    }]
  }
  private graficasActivoPasivo(){
    let posAct = this.tablaConfig.filas.findIndex( i => i.id == 'SUBTOTAL_01');
    let posPas = this.tablaConfig.filas.findIndex( i => i.id == 'SUBTOTAL_02');
    let activos = this.tablaConfig.filas.slice(0, posAct);
    let pasivos = this.tablaConfig.filas.slice(posAct+1, posPas);
    this.grafActivos.titulo = `${this.translate.instant('liquidez.calces.composicionActivos')} | 
        ${this.translate.instant('liquidez.calces.'+this.monedaSelec.tit)} | ${this.bandaSelec.titulo}`;
    this.grafPasivos.titulo = `${this.translate.instant('liquidez.calces.composicionPasivos')} | 
        ${this.translate.instant('liquidez.calces.'+this.monedaSelec.tit)} | ${this.bandaSelec.titulo}`;
    let act = [], pas = [];
    let index = this.bandas.findIndex(i => i == this.bandaSelec);
    for(const a of activos){
      this.grafActivos.etiquetas.push(a.descripcion);
      act.push(a.bandasValue[index] ?? 0)
    }
    for(const p of pasivos){
      this.grafPasivos.etiquetas.push(p.descripcion);
      pas.push(p.bandasValue[index] ?? 0)
    }
    this.grafActivos.data = [
      {
        name: '',
        data: act
      }
    ];
    this.grafPasivos.data = [{
      name: '',
      data: pas
    }];
  }
  public cambioPeriodo(per) {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
          this.periodoSeleccionado = per;
        } else {
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }
  public async cambioTipoMoneda(click: any) {
    for (const t of this.tipoMoneda) {
      if (t.name === click.name) {
        t.check = true;
      }else{
        t.check = false;
      }
    }
    this.monedaSelec = click;
    this.getDataFlujos();
    this.getDataFEC();
  }
  public ampliarGraf(zona){
    if(zona == 1){
      this.tituloModal = `${this.translate.instant('liquidez.calces.titCalces')} | ${this.translate.instant('liquidez.calces.'+this.monedaSeleccionada)}`;
      this.subtituloModal = this.periodoSeleccionado.periodo
    }
    if(zona == 2){
      this.tituloModal = `${this.translate.instant('liquidez.calces.titComposicion')} | ${this.translate.instant('liquidez.calces.mn-me')}`;
      this.subtituloModal = this.periodoSeleccionado.periodo
    }
    if(zona == 3){
      this.subtituloModal = this.periodoSeleccionado.periodo
      this.tituloModal = this.grafActivos.titulo;
    }
    if(zona == 4){
      this.subtituloModal = this.periodoSeleccionado.periodo
      this.tituloModal = this.grafPasivos.titulo;
    }
    this.modalOpen = true;
    this.graficaAmp = zona;
  }
  public exportarGrafica(zona) {
    var titulos;
    if(zona === 1){
      titulos = {
        titulo: `${this.translate.instant('liquidez.calces.titCalces')} | ${this.translate.instant('liquidez.calces.'+this.monedaSeleccionada)}`,
        subtitulo: this.periodoSeleccionado.periodo,
        nombreArch: `Calces de plazos`
      }
    }
    if(zona === 2){
      titulos = {
        titulo: `${this.translate.instant('liquidez.calces.titComposicion')} | ${this.translate.instant('liquidez.calces.mn-me')}`,
        subtitulo: `${this.periodoSeleccionado?.periodo}`,
        nombreArch: `Composicion activos-liquidos`
      }
    }
    if(zona === 3){
      titulos = {
        titulo: this.grafActivos.titulo,
        subtitulo: `${this.periodoSeleccionado?.periodo}`,
        nombreArch: `Composicion activos`
      }
    }
    if(zona === 4){
      titulos = {
        titulo: this.grafPasivos.titulo,
        subtitulo: `${this.periodoSeleccionado?.periodo}`,
        nombreArch: `Composicion pasivos`
      }
    }
    const comp = this.grafCmp.find(g => g.zona === zona)
    comp.exportImg(zona, titulos);    
  }
  public cambiarGrafica(tipo, zona){
    switch(zona){
      case 1:
        if(tipo !== 'TABLA'){
          this.verTablaCalce = true;
          this.grafCalce.tipo = this.typeGrap[tipo];
        }else{
          this.verTablaCalce = false;
          this.grafCalce.tipo = this.typeGrap.LINE;
        }
        break;
      case 2:
        if(tipo !== 'TABLA'){
          this.verTablaComp = false;
          this.grafComposicion.tipo = this.typeGrap[tipo];

        }else{
          this.verTablaComp = true;
          this.grafComposicion.tipo = this.typeGrap.COMBO;
        }
        break;
      case 3:
        this.grafActivos.tipo = this.typeGrap[tipo];
        break;
      case 4:
        this.grafPasivos.tipo = this.typeGrap[tipo];
        break;      
    }
    this.cdr.detectChanges();
  }
  public cambiarBanda(banda){
    this.bandaSelec = banda;
    this.graficasActivoPasivo();
  }
  public showAndHide(fila){
    const filas = this.tablaConfig.filas;
    const filter = filas.filter(f => fila.sumar.includes(f.id));
    
    filter.forEach(f =>{
      f.visible = !f.visible;
    });
    
    fila.expandido = !fila.expandido;
  }
  public exportarTabla(zona){
    if(zona == 1){
      let encabezados = this.tablaConfig.columnas;
      let data = [], colspan = [];
      const numMon = this.monedaSelec.id == 1 ? 2 : 1;
      for(const t of this.tablaConfig.filas){
        let aux = [];
        if(t.type !== "subtotal" && t.type !== 'titulo'){
          colspan.push(false);
          if(this.monedaSelec.id == 1 || this.monedaSelec.id == 2)
            aux.push(this.getCodigoPropio(t.sumar[0]) ?? '')
          if(this.monedaSelec.id == 1 || this.monedaSelec.id == 3)
            aux.push(this.getCodigoPropio(t.sumar[1]) ?? '');
          aux.push(t.descripcion);
        }else{
          colspan.push(true);
          aux.push(t.descripcion);
          if(this.monedaSelec.id == 1 || this.monedaSelec.id == 2)
            aux.push('')
          if(this.monedaSelec.id == 1 || this.monedaSelec.id == 3)
            aux.push('');
        }
        for(const b of t.bandasValue){
          aux.push(b);
        }
        data.push(aux);
      }

      let tituloHoja = `${this.translate.instant('liquidez.calces.titCalces')} | ${this.translate.instant('liquidez.calces.'+this.monedaSelec.tit)} | ${this.periodoSeleccionado.periodo}`
      let nombreArch = `${this.translate.instant('liquidez.calces.titCalces')} ${this.translate.instant('liquidez.calces.'+this.monedaSelec.tit)} ${this.periodoSeleccionado.periodo}`
      this.excelService.excelCalcePlazos(tituloHoja, encabezados, data, nombreArch, colspan, numMon);
    }
    if(zona == 2){ //exportar tabla de compisicion
      const encabezados = [
        this.translate.instant('liquidez.calces.descripcion'),
        this.translate.instant('liquidez.calces.mn'),
        this.translate.instant('liquidez.calces.me'),
        this.translate.instant('liquidez.calces.total'),
      ];
      const alineacion = [Aligment.LEFT, Aligment.RIGHT, Aligment.RIGHT, Aligment.RIGHT];
      const formatos = [FormatText.TEXT, FormatText.NUMBERDEC, FormatText.NUMBERDEC, FormatText.NUMBERDEC];
      const titulo = `${this.translate.instant('liquidez.calces.titComposicion')} | ${this.translate.instant('liquidez.calces.mn-me')} | ${this.periodoSeleccionado.periodo}`;
      const nombreArchivo = `${this.translate.instant('liquidez.calces.titComposicion')} ${this.translate.instant('liquidez.calces.mn-me')} ${this.periodoSeleccionado.periodo}`;
      let data = [];
      this.dataComposicion.forEach(d => {
        let aux = [];
        aux.push(d.descripcion);
        aux.push(d.mn);
        aux.push(d.me);
        aux.push(d.total);
        data.push(aux);
      });
      this.excelService.generateExcel(titulo, encabezados, data, nombreArchivo, alineacion, formatos);
    }
    if(zona === 3){
      let encabezados = [], alineacion = [Aligment.LEFT], formatos = [FormatText.TEXT];
      for(let e of this.tablaFEC.columnas){
        encabezados.push(e);
        alineacion.push(Aligment.RIGHT);
        formatos.push(FormatText.NUMBERDEC);
      }
      const titulo = `${this.translate.instant('liquidez.calces.titFEC')} | ${this.translate.instant('liquidez.calces.'+this.monedaSelec.tit)} | ${this.periodoSeleccionado.periodo}`;
      const nombreArchivo = `${this.translate.instant('liquidez.calces.titFEC')} ${this.translate.instant('liquidez.calces.'+this.monedaSelec.tit)} ${this.periodoSeleccionado.periodo}`;
      let data = [];
      this.tablaFEC.filas.forEach(d => {
        let aux = [];
        aux.push(d.descripcion);
        for(const b of d.bandasValue){
          aux.push(b);
        }
        data.push(aux)
      });
      this.excelService.generateExcel(titulo, encabezados, data, nombreArchivo, alineacion, formatos);
    }
  }
  public getCodigoPropio(cod){
    if(this.codigoPropio)
      return obtenerCodigoPropio.idsCodigoPropio(this.cuentaEntity.Id_Plantilla, cod)?.codigo;
  }
}
